<h2
  mat-dialog-title
  style="background-color: #003366; color: white; padding: 10px"
>
  Hay cambios sin guardar
</h2>
<mat-dialog-content
  style="display: flex; justify-content: space-around; padding: 20px"
>
  <p>No se han guardado los cambios en Feriados.</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center; padding-bottom: 20px">
  <app-boton-primario
    boton_texto="Guardar"
    (boton_funcion)="guardar()"
  ></app-boton-primario>
  <div style="margin-left: 10px">
    <app-boton-primario
      boton_texto="Salir sin guardar"
      (boton_funcion)="salirSinGuardar()"
      clase="red"
    ></app-boton-primario>
  </div>
</mat-dialog-actions>
